export enum EntryType {
  Undefined,
  Driver,
  Pedestrian,
  Passenger,
  Other,
}
